import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import CountdownTimer from './CountdownTimer';

const { FiTrendingUp, FiCalendar, FiMapPin, FiUsers } = FiIcons;

const Hero = ({ onBooking }) => {
  return (
    <section className="pt-24 pb-16 px-4 relative overflow-hidden">
      {/* Background decorative images */}
      <div className="absolute inset-0 opacity-20">
        <img 
          src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1751395116502-blob" 
          alt="Background" 
          className="absolute top-0 left-0 w-full h-full object-cover" 
        />
        <img 
          src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1751394087849-blob" 
          alt="Instructor" 
          className="absolute bottom-0 right-0 w-1/3 h-2/3 object-cover rounded-tl-3xl opacity-60" 
        />
      </div>
      
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/70 via-slate-800/50 to-slate-900/80"></div>
      
      <div className="container mx-auto text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto"
        >
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-yellow-600">
              วิชาปาจื้อเรียกทรัพย์
            </span>
            <br />
            <span className="text-2xl md:text-4xl">
              BAZI CHINESE ASTROLOGY FOR
            </span>
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-500">
              GETTING MONEY
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-slate-300 mb-8 font-light">
            เรียนรู้<span className="text-amber-400 font-semibold">วิชาปาจื้อเรียกทรัพย์</span>และ<span className="text-green-400 font-semibold">สร้างความมั่งคั่ง</span>
            <br />
            ด้วยศาสตร์โบราณที่มีหลักการชัดเจน
          </p>
          
          {/* Subtle Deadline Alert */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="bg-slate-700/40 backdrop-blur-md rounded-lg p-4 border border-slate-600/30 mb-8 max-w-2xl mx-auto"
          >
            <p className="text-slate-300 font-medium text-lg mb-1">
              ⏰ ใกล้ปิดรับสมัครแล้ว
            </p>
            <p className="text-amber-300 text-sm">
              📅 วันเรียน: 12 กรกฎาคม 2568 | ⏰ 09.00-17.00 น.
            </p>
          </motion.div>

          {/* Countdown Timer */}
          <CountdownTimer />
          
          <div className="grid md:grid-cols-4 gap-4 mb-10 text-center">
            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-3 border border-amber-500/20">
              <SafeIcon icon={FiMapPin} className="text-amber-400 text-xl mx-auto mb-1" />
              <p className="text-white font-semibold text-sm">S Ratchada Leisure Hotel</p>
              <p className="text-slate-400 text-xs">ห้อง Galleria ชั้น 2</p>
            </div>
            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-3 border border-purple-500/20">
              <SafeIcon icon={FiUsers} className="text-purple-400 text-xl mx-auto mb-1" />
              <p className="text-white font-semibold text-sm">ยันต์ "ฮู้" จีน</p>
              <p className="text-purple-400 text-xs">20 คนแรก</p>
            </div>
            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-3 border border-green-500/20">
              <SafeIcon icon={FiTrendingUp} className="text-green-400 text-xl mx-auto mb-1" />
              <p className="text-white font-semibold text-sm">รองรับสูงสุด</p>
              <p className="text-green-400 text-xs">35 คน</p>
            </div>
            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-3 border border-slate-500/30">
              <SafeIcon icon={FiCalendar} className="text-slate-300 text-xl mx-auto mb-1" />
              <p className="text-white font-semibold text-sm">เหลือเวลา</p>
              <p className="text-slate-300 text-xs font-bold">จำกัด!</p>
            </div>
          </div>
          
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onBooking}
            className="bg-gradient-to-r from-amber-500 to-yellow-600 text-white px-12 py-4 rounded-full text-xl font-bold shadow-2xl hover:shadow-amber-500/25 transition-all duration-300 mb-4"
          >
            เรียนรู้เดี๋ยวนี้
          </motion.button>
          
          <p className="text-slate-400 text-sm">
            คลิกเพื่อดูรายละเอียดและจองที่นั่ง
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;